import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file General settings store
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { SettingsOverviewDTOLayer } from '../../transportLayers/settings/SettingsOverviewDTOLayer';
import { SelloutItemFilter } from '@logio/common-be-fe';
export var SettingsOverviewDTOStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SettingsOverviewDTOStore, _BaseStore);

  function SettingsOverviewDTOStore(rootStore) {
    var _this;

    _classCallCheck(this, SettingsOverviewDTOStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsOverviewDTOStore).call(this, rootStore));
    _this.name = StoreName.SettingsOverviewDTOStore;
    _this.settingsDetailDTOLayer = new SettingsOverviewDTOLayer();
    _this.overview = new Map();
    return _this;
  }

  _createClass(SettingsOverviewDTOStore, [{
    key: "getOverview",
    value: function getOverview(releaseId) {
      var _this2 = this;

      return this.settingsDetailDTOLayer.getOverview(releaseId).then(function (overviews) {
        runInAction(function () {
          _this2.overview = overviews;
        });
        return _this2.overview;
      });
    }
  }, {
    key: "getSelloutOverview",
    value: function getSelloutOverview(releaseId, itemFilterHash) {
      var _this3 = this;

      runInAction(function () {
        return _this3.overview = new Map();
      });
      return this.settingsDetailDTOLayer.getSelloutOverview(releaseId, itemFilterHash).then(function (overviews) {
        runInAction(function () {
          _this3.overview = overviews;
        });
        return _this3.overview;
      });
    }
  }, {
    key: "computeSelloutOverview",
    value: function computeSelloutOverview(releaseId, itemFilter) {
      var _this4 = this;

      return this.settingsDetailDTOLayer.calculateSelloutReleasePreview(releaseId, itemFilter).then(function (progressMonitorId) {
        runInAction(function () {
          return _this4.progressMonitorId = progressMonitorId;
        });
        return progressMonitorId;
      });
    }
  }, {
    key: "includeCategoriesToSelloutRelease",
    value: function includeCategoriesToSelloutRelease(releaseId, productCategoryIds) {
      var _this5 = this;

      return this.settingsDetailDTOLayer.includeCategoriesToSelloutRelease(releaseId, productCategoryIds).then(function (updatedOverviews) {
        // FIXME: This action will rerender whole grid
        runInAction(function () {
          updatedOverviews.forEach(function (updatedOverview) {
            _this5.overview.set(updatedOverview.productCategoryId, updatedOverview);
          });
        });
      });
    }
  }, {
    key: "includeCategoriesToRelease",
    value: function includeCategoriesToRelease(releaseId, productCategoryIds) {
      var _this6 = this;

      return this.settingsDetailDTOLayer.includeCategoriesToRelease(releaseId, productCategoryIds).then(function (updatedOverviews) {
        // FIXME: This action will rerender whole grid
        runInAction(function () {
          updatedOverviews.forEach(function (updatedOverview) {
            _this6.overview.set(updatedOverview.productCategoryId, updatedOverview);
          });
        });
      });
    }
  }, {
    key: "excludeCategoriesToRelease",
    value: function excludeCategoriesToRelease(releaseId, productCategoryIds) {
      var _this7 = this;

      return this.settingsDetailDTOLayer.excludeCategoriesToRelease(releaseId, productCategoryIds).then(function (updatedOverviews) {
        runInAction(function () {
          updatedOverviews.forEach(function (updatedOverview) {
            _this7.overview.set(updatedOverview.productCategoryId, updatedOverview);
          });
        });
      });
    }
  }, {
    key: "excludeCategoriesToSelloutRelease",
    value: function excludeCategoriesToSelloutRelease(releaseId, productCategoryIds) {
      var _this8 = this;

      return this.settingsDetailDTOLayer.excludeCategoriesToSelloutRelease(releaseId, productCategoryIds).then(function (updatedOverviews) {
        runInAction(function () {
          updatedOverviews.forEach(function (updatedOverview) {
            _this8.overview.set(updatedOverview.productCategoryId, updatedOverview);
          });
        });
      });
    }
  }]);

  return SettingsOverviewDTOStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], SettingsOverviewDTOStore.prototype, "overview", void 0);

__decorate([observable, __metadata("design:type", String)], SettingsOverviewDTOStore.prototype, "progressMonitorId", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], SettingsOverviewDTOStore.prototype, "getOverview", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], SettingsOverviewDTOStore.prototype, "getSelloutOverview", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String, SelloutItemFilter]), __metadata("design:returntype", Promise)], SettingsOverviewDTOStore.prototype, "computeSelloutOverview", null);